export enum DATA_QA {
  ROOT = 'end-campaign',
  CANCEL = 'end-campaign__cancel',
  CONFIRM = 'end-campaign__confirm',
}
